// FindContradictionsRoutine output schemas — mirrors backend
// src/agent/routines/schemas/find_contradictions.py
//
// The structured pairs are surfaced through ChatMessageContent.metadata.contradictions
// (see chat_service._serialize_contradictions on the backend) and rendered as
// clickable cards in the chat window.

export enum ContradictionSeverity {
    DIRECT = "DIRECT",
    PARTIAL = "PARTIAL",
    IMPLIED = "IMPLIED",
}

export const ContradictionSeverityLabels: Record<ContradictionSeverity, string> = {
    [ContradictionSeverity.DIRECT]: "Direct",
    [ContradictionSeverity.PARTIAL]: "Partial",
    [ContradictionSeverity.IMPLIED]: "Implied",
};

/** One side of a contradiction pair, with enough metadata to spotlight the source. */
export interface ContradictionSide {
    speaker: string;
    quote: string;
    doc_id?: string | null;
    doc_title?: string | null;
    page_start?: number | null;
    line_start?: number | null;
    line_end?: number | null;
    reference_id?: string | null;
}

export interface ContradictionPair {
    topic: string;
    severity: ContradictionSeverity;
    explanation: string;
    left: ContradictionSide;
    right: ContradictionSide;
}
